import { render, staticRenderFns } from "./ShipperAfiliator.vue?vue&type=template&id=66be1908"
import script from "./ShipperAfiliator.vue?vue&type=script&lang=js"
export * from "./ShipperAfiliator.vue?vue&type=script&lang=js"
import style0 from "./ShipperAfiliator.vue?vue&type=style&index=0&id=66be1908&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports